module.exports = __webpack_public_path__ + "images/industrial-6-146f9c7a4c3b4e8845fc19cacf842ec5.jpg";